const translations = {
    boundary: 'Boundary',
    noAddress: 'No address',
    noBoundary: 'No boundary'
};

export default translations;
